import * as TENANTS_ALL from 'shared/consts/tenants'

export const TENANTS = Object.values(TENANTS_ALL)
